import {
    CartItemTitle,
    MarginTopDiv,
    CostContainer,
    StyledButton,
    ButtonText,
    SubsidyText,
    TooltipTitle,
    DetailsPrice,
} from "./cart.styled";
import InfoContainer from "@/components/Info-container";
import HtmlTooltip from "@/components/htmlTooltip";
import amountToFixed from "@/helper/amountToFixed";
import { useMainPageContext } from "@/contexts/MainPageContext";
import { useContext } from "react";
import { AppContext } from "@/contexts/AppContext";

export default function CartSubTotal({ actionButtonText }) {
    const { itbis, subTotal, toUseBenefits, amountToProcess, cashOrCardValue, discountAmount } = useContext(AppContext);
    const { setOpenModal, openNotEnoughBalanceMessage } = useMainPageContext();
    return (
        <MarginTopDiv>
            {cashOrCardValue ? <InfoContainer cashOrCardValue={cashOrCardValue} /> : null}
             {discountAmount > 0 && (
                    <>
                        <CostContainer>
                            <CartItemTitle>Subtotal Pre descuento</CartItemTitle>
                            <DetailsPrice>{`RD$ ${amountToFixed(subTotal + discountAmount, 2)}`}</DetailsPrice>
                        </CostContainer>
                        <CostContainer>
                            <SubsidyText textcolor="#6ec4e8">Descuento</SubsidyText>
                            <SubsidyText textcolor="#6ec4e8">{`RD$ ${amountToFixed(discountAmount, 2)}`}</SubsidyText>
                        </CostContainer>
                    </>
                )}
            <HtmlTooltip
                arrow
                open={openNotEnoughBalanceMessage}
                placement="top-start"
                title={<TooltipTitle>No hay suficiente balance</TooltipTitle>}
            >
                <CostContainer>
                    <CartItemTitle>Subtotal</CartItemTitle>
                    <DetailsPrice>{`RD$ ${amountToFixed(subTotal, 2)}`}</DetailsPrice>
                </CostContainer>
            </HtmlTooltip>
            {Object.entries(itbis).map((entry) => (
                <CostContainer key={entry[0]}>
                    <CartItemTitle>{entry[0]}</CartItemTitle>
                    <DetailsPrice>{`RD$ ${amountToFixed(entry[1], 2)}`}</DetailsPrice>
                </CostContainer>
            ))}
            {Object.entries(toUseBenefits).filter((entry)=>entry[1] > 0).map((entry) => (
                <CostContainer key={entry[0]}>
                    <SubsidyText textcolor="#6ec4e8">{entry[0][0].toUpperCase() + entry[0].slice(1)}</SubsidyText>
                    <SubsidyText textcolor="#6ec4e8">{`RD$ ${amountToFixed(entry[1], 2)}`}</SubsidyText>
                </CostContainer>
            ))}
            <StyledButton onClick={() => setOpenModal(true)} variant="contained">
                <ButtonText>{actionButtonText}</ButtonText>
                <ButtonText bold>{`RD$ ${amountToFixed(amountToProcess, 2)}`}</ButtonText>
            </StyledButton>
        </MarginTopDiv>
    );
};
